/* eslint-disable import/no-unresolved */
import React, { useEffect, useState, useContext } from 'react';
import { Helmet } from 'react-helmet';
import { useParams } from 'react-router-dom';
import { useBrandDetails } from 'dw-au-react-components';
import { LoadingIcon } from '../../components/LoadingIcon';
import { ContentfulContext } from '../../context/Contentful';
import Banner from './Banner';
import BodyContent from './BodyContent';
import ProgressBar from './ProgressBar';

const BlogDetail = () => {
	let { slug } = useParams();
	const { name } = useBrandDetails();
	const { blogLandingData } = useContext(ContentfulContext);
	const [blogDetailData, setBlogDetailData] = useState(null);
	const [isLoading, setIsLoading] = useState(false);

	const [productCarouselHTMLContent, setProductCarouselHTMLContent] = useState(
		''
	);

	useEffect(() => {
		fetch('/assets/apps/au/product_carousel/index.html')
			.then((res) => res.text())
			.then((data) => setProductCarouselHTMLContent(data));
	}, []);

	useEffect(() => {
		const productCarouselContainer = document.getElementById(
			'product_carousel_container'
		);
		if (productCarouselHTMLContent !== '' && productCarouselContainer) {
			productCarouselContainer.innerHTML = productCarouselHTMLContent;
			const scripts = productCarouselContainer.getElementsByTagName('script');
			for (let script of scripts) {
				const newScript = document.createElement('script');
				newScript.src = script.src;
				newScript.text = script.text;
				newScript.async = false;
				script.parentNode.replaceChild(newScript, script);
			}
		}
	}, [productCarouselHTMLContent]);

	useEffect(() => {
		const filteredData = blogLandingData.filter((item) => {
			setIsLoading(true);
			return item.path === slug;
		});
		setBlogDetailData(filteredData[0]);
		setIsLoading(false);
	}, [blogLandingData, slug]);

	useEffect(() => {
		// eslint-disable-next-line no-undef
		recommendations.fetchSingleData();
		window.scrollTo(0, 0);
	}, []);

	if (isLoading) {
		return <LoadingIcon />;
	}

	return (
		<>
			{blogDetailData ? (
				<>
					<Helmet>
						<title>
							{blogDetailData?.metaTitle ?? blogDetailData?.title} - Blog -{' '}
							{name}
						</title>
						<meta
							name='description'
							content={
								blogDetailData?.metaDescription ?? blogDetailData?.headline
							}
						/>
						<link rel='canonical' href={location?.href}></link>
					</Helmet>
					<ProgressBar />
					<Banner
						bannerData={blogDetailData?.bannerImage}
						bannerTitle={blogDetailData?.title}
					/>
					<BodyContent
						bodyContent={blogDetailData?.content}
						bodyContentV2={blogDetailData?.contentNew}
						title={blogDetailData?.title}
						categoryTitle={blogDetailData?.blogCategory}
					/>

					{/* <section className='homepage__section homepage__recommender'>
						<div className='container'>
							<h5 className='font-noto lower light text-center mb-20'>
								We think you&#39;ll love
							</h5>
							<div
								className='slider__section position-relative mb-80'
								id='homepage__recommender'
							>
								<div className='loader-new hideInitially w-100 h-100 d-flex justify-content-center align-items-center loading'>
									<svg
										className='loader-new__inner'
										viewBox='0 0 66 66'
										xmlns='http://www.w3.org/2000/svg'
									>
										<circle
											className='loader-new__circle'
											fill='none'
											cx='33'
											cy='33'
											r='30'
										></circle>
									</svg>
								</div>
							</div>
						</div>
					</section> */}
				</>
			) : (
				'Not Found'
			)}
		</>
	);
};

export default BlogDetail;
